import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export default function useRegistrationAgreementState(
  initialValue: boolean = false,
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [confirmed, setConfirmed] = useState<boolean>(initialValue)

  const isCustomRegistrationAgreementStore = useSelector(
    (store: any) => store.settings.isCustomRegistrationAgreement === '1',
  )
  const isDefaultCheckedStore = useSelector(
    (store: any) =>
      store.settings.isCustomRegistrationAgreementDefaultChecked === '1',
  )

  useEffect(() => {
    if (isCustomRegistrationAgreementStore) {
      setConfirmed(isDefaultCheckedStore)
    } else {
      setConfirmed(true)
    }
  }, [isDefaultCheckedStore, isCustomRegistrationAgreementStore])

  return [confirmed, setConfirmed]
}
